/*
      auto generated  Wednesday, August 5, 2026 16:33:12 PM
      script          /make.php
      do not modify - changes do not persist
*/
const data={
SIO_PATH:'/sio/socket.io',
DEV_PATH:'/browser-sync/socket.io',
SIO_NAMESPACE:'/',
DEV_NAMESPACE:'/ps',
DEV_PORT:3000,
UI_DEV_PORT:3001,
DEV_BUILD_PORT:4000,
UI_DEV_BUILD_PORT:4001,
QID:987644321,
DOMAIN:'paksof.com',
DOMAIN_LEN:10,
ROOT:'r10',
LIMIT:10,
PUB:'<>0',
PRI:'=0',
PREVIEW_404:'not found',
LIFETIME:2147483647,
STAGE_M:3,
RATE_M:5,
USERNAME_MIN:4,
PASSWORD_MIN:8,
PASSWORD_M:64,
USERNAME_M:64,
CURRENCY_M:8,
HOST_M:8,
TABLE_M:16,
TEL_M:32,
IP_M:16,
CODE_M:16,
NAME_M:64,
CLOSE_M:64,
OPEN_M:64,
LINE_M:64,
URI_M:64,
TITLE_M:128,
TYPE_M:64,
REF_M:128,
COUNTRY_M:64,
EMAIL_M:64,
DESC_M:256,
MEMO_M:512,
DETAIL_M:1024,
VERBAL_M:5120,
PHONE_M:128,
COUNTRY2_M:2,
UNIT_M:32,
BUZZER_M:32,
CITY_M:64,
STATE_M:64,
TIP_M:32,
PRINT_M:2147483647,
EN:'en',
FR:'fr',
SD:'sd',
UR:'ur',
AR:'ar',
FA:'fa',
HI:'hi',
PU:'pu',
CN:'zh-CN',
TD:'zh-TD',
PA:'pa',
LTR_:["en","fr","zh-CN","zh-TD","hi","pa"],
RTL_:["sd","fa","ar","ur","pu"],
LANG_:["en","fr","ur"],
EVENT_:["io","vendor","user"],
ADMIN_:{"home":"home"},
SQL_:["insert","delete","update","default"],
COM_:["from","to"],
IDS_:["customer","vendor","employee","shipper","driver"],
PKS_:["customer","vendor","employee","shipper","driver","from","to"],
LOGIN_:{"profile":"update","logout":"delete","reset":"reset"},
LOGIN_FLIP_:{"update":"profile","delete":"logout","reset":"reset"},
LOGOUT_:{"login":"default","register":"insert","forget":"forget"},
LOGOUT_FLIP_:{"default":"login","insert":"register","forget":"forget"},
USER_:["login","register","forget","profile","logout","reset"],
MASTER_:["page","error","login","register","forget","profile","logout","reset"],
VERB_:["home","insert","delete","update","default","login","register","forget","profile","logout","reset","bulk","otp"],
TITLE_:["master","ride","deliver"],
JSON_:{"selectmedia":"media","selectitem":"item","selectreview":"review","medias":"media","items":"item","reviews":"review","pages":"page"},
JSONCART_:["pk","stock","price","v"],
ADDRESS_:["unit","buzzer","address","city","state","code","country"],
DELIVER_:["map","offer","tip","cost"],
JSONDELIVER_:["map","phone","memo","offer","tip","cost"],
JSON_FLIP_:{"media":"medias","item":"items","review":"reviews","page":"pages"},
FILE_OPTIONAL_:["hours","news","about","help","feed","review"],
STORE_:["config","hours","sale","menu","news","about","help","feed"],
COUNT_:["item","review","follow","config","hours","sale","menu","news","about","help"],
SELL_:["sale","item"],
FILE_:["config","hours","sale","menu","news","about","help","feed","item","review"],
CART_:["sales","purchase","receipt"],
CONFIG_:["sales","purchase","receipt","sale","item"],
PRIVATE_:["media","sales","purchase","receipt","q","notice","follow","chat","follows","review"],
NO_NEW_:["sales","purchase","receipt","q","notice","follow","chat","follows","review"],
Q_:["config","hours","sale","menu","news","about","help","feed","item","review","media","sales","purchase","receipt","q","notice","follow","chat","follows"],
SCREEN_:["welcome","ride","parcel","search","stage","driver","deliver","sponsor"],
LOCAL_:["edit","online","pay","paid","ride","welcome","ride","parcel","search","stage","driver","deliver","sponsor"],
PART_:["config","hours","sale","menu","news","about","help","feed","item","review","media","sales","purchase","receipt","q","notice","follow","chat","follows","edit","online","pay","paid","ride","welcome","parcel","search","stage","driver","deliver","sponsor","page","error","login","register","forget","profile","logout","reset"],
PRINT_:["config","hours","news","menu","item","about","help","stage"]
}
export default data